import { render, staticRenderFns } from "./AddEditCategory.vue?vue&type=template&id=0936c23c&"
import script from "./AddEditCategory.vue?vue&type=script&lang=ts&"
export * from "./AddEditCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports